<template>
  <b-overlay :show="load" rounded="sm">
    <div class="media-list media-bordered mycomments" ref="comments">
      <b-media v-for="comment in comments" :key="comment.id">
        <template #aside>
          <b-avatar rounded size="42" :src="comment.user.profile_image_path" />
        </template>

        <h5 class="mt-0">{{ comment.user.full_name }}</h5>
        <b-card-text>{{ comment.created_at }}</b-card-text>
        <b-card-text>
          <b-row>
            <b-col lg="11">
              <span v-if="comment.type == 'text'">
                {{ comment.text }}
              </span>
              <span v-if="comment.type == 'audio'">
                <audio controls :src="comment.meida_data"></audio>
              </span>
              <span v-if="comment.type == 'video'">
                <video
                  width="400"
                  height="250"
                  controls
                  :src="comment.meida_data"
                ></video
              ></span>
            </b-col>
            <b-col lg="1" v-if="user.account_type != 'student'">
              <b-button
                variant="gradient-danger"
                class="btn-icon"
                @click="Delete(comment.id)"
              >
                <feather-icon icon="TrashIcon" /> </b-button
            ></b-col>
          </b-row>
        </b-card-text>

        <b-media
          class="mt-3"
          v-for="children in comment.children"
          :key="children.id"
        >
          <template #aside>
            <b-avatar
              rounded
              size="42"
              :src="children.user.profile_image_path"
            />
          </template>

          <h5 class="mt-0">{{ children.user.full_name }}</h5>
          <b-card-text>{{ children.created_at }}</b-card-text>
          <b-card-text class="mb-0">
            <b-row>
              <b-col lg="11">
                <div v-if="children.type == 'text'">
                  {{ children.text }}
                </div>
              </b-col>
              <b-col lg="1" v-if="user.account_type != 'student'">
                <b-button
                  variant="gradient-danger"
                  class="btn-icon"
                  @click="Delete(children.id)"
                >
                  <feather-icon icon="TrashIcon" /> </b-button
              ></b-col>
            </b-row>
          </b-card-text>
        </b-media>
        <b-media class="mt-3">
          <b-card>
            <b-form>
              <b-row>
                <b-col cols="9">
                  <b-form-group class="mb-2">
                    <b-form-input
                      id="basicInput"
                      :placeholder="$t('comment.comment')"
                      v-model="textCh[comment.id]"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="3">
                  <b-button
                    variant="primary"
                    @click="add(comment.id, textCh[comment.id])"
                  >
                    {{ $t("comment.add_comment") }}
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-media>
      </b-media>
    </div>
    <!-- Leave a Blog Comment -->
    <hr />
    <b-col cols="12" class="mt-2">
      <h6 class="section-label">{{ $t("comment.leave_comment") }}</h6>
      <b-card>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-tabs content-class="pt-1" fill v-model="commentTab">
                <b-tab :title="$t('comment.text')">
                  <b-form-group class="mb-2">
                    <b-form-textarea
                      name="textarea"
                      v-model="text"
                      rows="4"
                      :placeholder="$t('comment.comment')"
                    />
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="9">
              <b-button variant="primary" @click="add(0)">
                {{ $t("comment.add_comment") }}
              </b-button>
            </b-col>

            <b-col cols="3" class="float-right">
              <b-button variant="info" @click="exportToPDF">
                {{ $t("comment.export_to_PDF") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
    <!--/ Leave a Blog Comment -->
  </b-overlay>
</template>

<script>
import Auth from "@/Apis/Auth";
import CommentController from "@/Controllers/CommentGeneralController";
// import html2pdf from "html2pdf.js";

let comment = new CommentController();
export default {
  props: {
    commentabletype: String,
    commentableid: Number,
    type: String,
  },
  data() {
    return {
      comments: [],
      text: "",
      textCh: [],
      load: false,
      audio: "",
      commentTab: 0,

      meidaData: null,
      stream: false,
      user: Auth.USER,
    };
  },
  async created() {
    this.get();
    console.log(this.commentabletype, this.commentableid);
  },
  methods: {
    async add(parent, text) {
      if (!text) text = this.text;
      let data = {
        commentable_type: this.commentabletype,
        commentable_id: this.commentableid,
        text: text,
        parent_id: parent,
        user_id: Auth.USER.id,
        type: "text",
      };

      const [ret, show] = await Promise.all([
        comment.From(data, "FromData"),
        this.get(),
      ]);
      this.textCh = [];
      this.text = "";
    },
    async get() {
      this.load = true;
      let res = await comment.GetAll({
        filter: `commentable_id|${this.commentableid}&&commentable_type|${this.commentabletype}`,
        with: ["user"],
      });

      this.comments = this.listToTree(res);
      console.log(this.comments);
      this.load = false;
      this.meidaData = null;
    },
    listToTree(list) {
      console.log(list);
      var map = {},
        node,
        roots = [],
        i;

      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i;
        list[i].children = [];
      }
      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (node.parent_id !== 0) {
          list[map[node.parent_id]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      return roots;
    },
    exportToPDF() {
      // html2pdf(this.$refs.comments, {
      //   margin: 1,
      //   filename: "comments.pdf",
      //   image: { type: "jpeg", quality: 0.98 },
      //   html2canvas: { dpi: 192, letterRendering: false },
      //   jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
      // });
      const collection = document.getElementsByClassName("mycomments");

      var opt = {
        margin: 1,
        filename: "myfile.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
      // New Promise-based usage:
      html2pdf().set(opt).from(collection[1]).save();
    },

    async Delete(id) {
      const [ret, show] = await Promise.all([comment.Delete(id), this.get()]);
    },
  },
};
</script>

<style>
</style>
